export function isUserUrlChangeValid(value: string) {
  if (!value.length) return 'This field is required'
  if (value.length < 6) return 'min 6 characters'
  if (value.length > 20) return 'max 20 characters'

  return ''
}
